import React from "react";
import useAuthorization from "../../../../custom-hooks/useAuthorization/useAuthorization";
import { AUTHORIZATIONS } from "../../../../utils/constants/authorization-constants";
import ProjectAssignmentsPendingExpenseReports from "../ProjectAssignmentsPendingExpenseReports/ProjectAssignmentsPendingExpenseReports";

const ProjectAssignmentsPendingExpenses = () => {
  const hasAccess = useAuthorization([AUTHORIZATIONS.EmployeesAccess.ApproveExpenses]);

  return (
    <>
      {hasAccess && (
        <>
          <ProjectAssignmentsPendingExpenseReports />
        </>
      )}
    </>
  );
};

export default ProjectAssignmentsPendingExpenses;
